import apiClient from '../../../lib/axios';

export const meetingManager = {

  create: async (params: any) => {
    try {
      const { data } = await apiClient.post('/meeting-manager', params);
      if (!data.status) {
        throw new Error(data.message || 'Failed to create meeting');
      }
      return data;
    } catch (error: any) {
      throw new Error(error?.message || 'Failed to create meeting');
    }
  },

  update: async (meetingId: string, updates: any[]) => {
    try {
      const { data } = await apiClient.put(`/meeting-manager/${meetingId}`, updates);
      if (!data.status) {
        throw new Error(data.message || 'Failed to update meeting');
      }
      return data;
    } catch (error: any) {
      throw new Error(error?.message || 'Failed to update meeting');
    }
  },

  getMeetingDetails: async (meetingId: string) => {
    try {
      const { data } = await apiClient.get(`/meeting-manager/${meetingId}`);
      if (!data.status) {
        throw new Error(data.message || 'Failed to fetch meeting details');
      }
      return data.data[0];
    } catch (error: any) {
      throw new Error(error?.message || 'Failed to fetch meeting details');
    }
  },

  getMeetings: async ({ page, limit, filterType }: { page: number; limit: number; filterType: 'upcoming' | 'completed' | 'overdue' }) => {
    try {
      const response = await apiClient.get('/meeting-manager/list', {
        params: { page, limit, filter_code: filterType }
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error?.message || 'Failed to fetch meeting details');
    }
  },

  // Add this to the meetingManager object
  generateMOM: async (meetingId: string) => {
    try {
      const { data } = await apiClient.post(
        '/pdf/generate',
        { type: 'meeting_manager', id: Number(meetingId) },
        { responseType: 'blob' }
      );
      return data; // Blob
    } catch (error: any) {
      throw new Error(error?.message || 'Failed to generate MOM');
    }
  }

};